/* istanbul ignore file */
let IsDevelopment = false;
let GlobalInfo: { [key: string]: any } = {}; // Allow any string keys
let LoginUserName = "";
let LoginUserID = "0";
let APPModuleID = "0";
let Privilegeslist: any[] = [];
let TenantId = "1";
let Privileges: string[] = [];
let AgentPrivilagesList: string[] = [];
let DomainName = "";
let TenantName = "";
let PrivilegesCookieKeyName = "USER_PRIVILEGES";
let Access_Token = "";
let IsChatbotAccessed = "true";
const hostname = window?.location?.hostname;
let RIApiUrl = "https://insightsapi.devsecops.freyafusion.com";
let DocChatUrl = "/gateway/InsightsOS/GetEncryptAttachmentName?fileName=";
let UserKey = '';
const jwtAuth = localStorage.getItem("ngStorage-JWTAUTH");
const accessTokenFromCookie = getCookieValue('ACCESS_TOKEN');
if (jwtAuth !== null) {
  UserKey = jwtAuth.replace(/^"(.+(?="$))"$/, '$1');
} else if (accessTokenFromCookie !== '') {
  UserKey = accessTokenFromCookie.replace(/^"(.+(?="$))"$/, '$1');
}
//collect values from local storage
if (getCookieValue('ACCESS_TOKEN') != "") { //Collect values from coockies
  Access_Token = getCookieValue('ACCESS_TOKEN')!.replace(/^"(.+(?="$))"$/, '$1');
  // Privilegeslist = '[{"AppModuleID":3,"PrivilegeCode":"ADM100","MenuCode":"ADM","Status":0,"AllAvailable":false,"Value":""}]';
  if (getCookieValue('USER_NAME') != "") {
    LoginUserName = getCookieValue('USER_NAME')!.replace(/^"(.+(?="$))"$/, '$1');
  }
  else if (getCookieValue('USER_EMAIL') != "") {
    LoginUserName = getCookieValue('USER_EMAIL')!.replace(/^"(.+(?="$))"$/, '$1');
  }
  if (getCookieValue('USER_ID') != "") {
    LoginUserID = getCookieValue('USER_ID')!.replace(/^"(.+(?="$))"$/, '$1');
  }
  if (getCookieValue('DomainID') != "") {
    APPModuleID = getCookieValue('DomainID')!.replace(/^"(.+(?="$))"$/, '$1');
  }
  // if (getCookieValue('USER_PRIVILEGES') != "") {
    
  //   Privileges = getCookieValue('USER_PRIVILEGES')!.replace(/^"(.+(?="$))"$/, '$1');
  // }
  if (getCookieValue('USER_TENANT_ID') != "") {
    TenantId = getCookieValue('USER_TENANT_ID')!.replace(/^"(.+(?="$))"$/, '$1');
  }
  if (getCookieValue('IsChatbotAccessed') != "") {
    IsChatbotAccessed = getCookieValue('IsChatbotAccessed')!.replace(/^"(.+(?="$))"$/, '$1');
  }
  if (getCookieValue('DOMAIN') != "") {
    DomainName = getCookieValue('DOMAIN')!.replace(/^"(.+(?="$))"$/, '$1');
  }
}

function getCookieValue(cookieName: string): string {
  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');

  for (const cookie of cookies) {
    let trimmedCookie = cookie.trim();
    if (trimmedCookie.startsWith(name)) {
      return trimmedCookie.substring(name.length);
    }
  }
  return '';
}



export const baseEnvironment = {
  production: true,
  baseUrl: '',
  apiKey: '',
  DomainName: DomainName,
  chatbotName: '',
  LoginUserName: LoginUserName,
  LoginUserID: LoginUserID,
  APPModuleID: APPModuleID,
  Privilegeslist: Privilegeslist,
  PrivilegesCookieKeyName: PrivilegesCookieKeyName,
  TenantId: TenantId,
  Privileges: Privileges,
  AgentPrivilagesList: AgentPrivilagesList,
  TenantName: TenantName,
  UserKey: UserKey,
  Access_Token: Access_Token,
  RIApiUrl: RIApiUrl,
  DocChatUrl: DocChatUrl,
  IsDevelopment: IsDevelopment,
  GlobalInfo: GlobalInfo
};